module.exports = __webpack_public_path__ + "static/media/brand_60.29d6a708.png";